<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All Referral Users</h5>
                <p class="mb-0 text-sm">
                  Below the list of Referral users.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <download-excel
                    class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                    :data="records"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="external-users.xls"
                  >
                    Export
                  </download-excel>
                </div>
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <div class="row">
                        <div class="col-5">
                          <div class="input-daterange datepicker row align-items-center" >
                            <base-input addon-left-icon="ni ni-calendar-grid-58" >
                            <date-range-picker
                                ref="picker"
                                :opens="opts.opens"
                                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                                :singleDatePicker="opts.singleDatePicker"
                                :showWeekNumbers="opts.showWeekNumbers"
                                :showDropdowns="opts.showDropdowns"
                                :autoApply="opts.autoApply"
                                :dateRange="opts.dateRange"
                                v-model="dates.range"
                                :linkedCalendars="opts.linkedCalendars"
                              >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ dateTime(picker.startDate) }} - {{ dateTime(picker.endDate) }}
                                </template>
                              </date-range-picker>
                            </base-input>
                          </div>
                      
                        </div>
                        <div class="col-5">
                          <input class="dataTable-input form-control" placeholder="Search..." type="text" v-model="search">
                        </div>
                        <div class="col">                                          
                          <button class="rounded btn btn-xs text-white bg-success" @click="getAllAPI()">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            Fullname
                          </th>
                          <th>
                            Email
                          </th>
                          <th>
                            Phone
                          </th>
                          <th>
                            Joined At
                          </th>
                          <th>
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ ((this.currentPage-1)*this.limitPerPage) + index+1 }}</td>
                          <td class="text-sm">{{ record.fullname }}</td>
                          <td class="text-sm">{{ record.username }}</td>
                          <td class="text-sm">{{ record.phone }}</td>
                          <td class="text-sm">{{ dateTime(record.created_at) }}</td>
                          <td>
                            <span class="badge badge-danger badge-sm" v-if="!record.is_active">Not Active</span>
                            <span class="badge badge-success badge-sm" v-else>Active</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import UsersService from "@/services/users.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';
  import JsonExcel from "vue-json-excel3";
  import DateRangePicker from 'vue3-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import BaseInput from "@/components/BaseInput.vue";
  const toastId = ref('');

  const moment = require('moment');
  

  export default {
    name: "ExternalUserList",
    data() {
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(startDate.getDate() - 30)

      return {
        opts: {
          dateRange: {startDate,endDate},
          opens: "left",
          minDate: new Date(),
          maxDate: new Date(),
          singleDatePicker: false,
          showWeekNumbers: true,
          autoApply: false,
          linkedCalendars: true,
        },
        dates: {
          range: {startDate: startDate, endDate: endDate}
        },
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        sortBy: {
          name: 'created_at',
          sortType: '-1'
        },
        search: '',
        json_fields: {
            "ID": "id",
            "Fullname": "fullname",
            "Email": "username",
            "Phone": "phone",
            "Birth Date": "birth_date",
            "Is Active": "is_active",            
            "Joined At": "created_at",            
          },
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(){
        toast.update(toastId.value, {
          render: "delete Successfully",
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      dateTimeV2(value) {
        return moment(value).format("YYYY-MM-DD");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        const params = {
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search,   
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate),
          referred_by: this.$route.params.id,       
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        UsersService.getAll(params).then(e => {
          const data = e.data
          this.records = data.listofregistrationdata
          this.totalRecords = data.count
        })
      }
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      downloadExcel:JsonExcel,
      BaseInput,
      DateRangePicker,

    },
    mounted() {
      this.getAllAPI()
    },
  };
  </script>
  